import React, {useCallback, useEffect} from 'react'
import {useWeb3React} from '@web3-react/core'
import {useSpring, animated} from 'react-spring'
import {CheckCircle, AlertCircle} from 'react-feather'
import {useRemovePopup} from "../../hooks";
import styled from "styled-components";

export const PopupItem = ({
                            removeAfterMs,
                            content,
                            popKey,
                            success,
                            hash,
                          }) => {
  const removePopup = useRemovePopup()

  const removeThisPopup = useCallback(() => removePopup(popKey), [
    popKey,
    removePopup,
  ])

  const {chainId} = useWeb3React()

  useEffect(() => {
    if (removeAfterMs === null) return undefined

    const timeout = setTimeout(() => {
      removeThisPopup()
    }, removeAfterMs)

    return () => {
      clearTimeout(timeout)
    }
  }, [removeAfterMs, removeThisPopup])

  const faderStyle = useSpring({
    from: {
      width: '100%',
      position: 'absolute',
      bottom: 0,
      left: 0,
      height: 2,
      backgroundColor: 'rgba(255, 255, 255, 0.6)',
    },
    to: {
      width: '0%',
      position: 'absolute',
      bottom: 0,
      left: 0,
      height: 2,
      backgroundColor: 'rgba(255, 255, 255, 0.6)',
    },
    config: {duration: removeAfterMs ?? undefined},
  })

  const Popup = styled.div`
display: inline-block;
  width: 100%;
  background: linear-gradient(0deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1)), #000000;
  position: relative;
  border-radius: 10px;
  padding: 20px;
  padding-right: 35px;
  overflow: hidden;
  word-break: break-all;

  &__frame {
    display: flex;
    flex-direction: column;

    &__content {
      display: flex;
      align-items: center;

      p {
        overflow:hidden;
        text-overflow:ellipsis;
        white-space:nowrap;
      }

      svg {
        margin-right: 12px;
      }
    }

    a {
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 148.69%;
      margin-top: 9px;
      text-decoration-line: underline;
      color: #ffffff;
      margin-left: 34px;

      &:hover {opacity: 0.6}
    }
  }
`

  return (
      <Popup>
        <div className="popup__frame">
          <div className="popup__frame__content">
            {success ? (
                <CheckCircle color={'#27AE60'} size={24}/>
            ) : (
                <AlertCircle color={'#FF6871'} size={24}/>
            )}
            <p>{content}</p>
          </div>

          {chainId && (
              <a href={hash} target="_blank" rel="noopener noreferrer">
                {hash ? hash.indexOf('https://bscscan.com') !== -1 ? 'Bscscan' :
                    hash.indexOf('https://hecoinfo.com') !== -1 ? 'Hecoinfo' : hash.indexOf('https://www.oklink.com/okexchain') !== -1 ? 'OKLink' : 'Etherscan' : ''}
              </a>
          )}
        </div>

        <animated.div style={faderStyle}/>
      </Popup>
  )
}
